import React, { createContext, useContext, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const SelectedColorContext = createContext()

export function SelectedColorProvider({ children }) {
  const [selectedColor, setSelectedColor] = useState(null)
  const { search } = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(search)
    const color = params.get('color')
    if (color) {
      setSelectedColor(color)
    }
  }, [search])

  return (
    <SelectedColorContext.Provider value={{ selectedColor, setSelectedColor }}>
      {children}
    </SelectedColorContext.Provider>
  )
}

export const useSelectedColor = () => useContext(SelectedColorContext)
